import { Injectable, inject } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Observable, ReplaySubject, of } from 'rxjs';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { ProductService } from 'app/core/product/product.service';
import { Router } from '@angular/router';
import { NavSidebarService } from 'app/core/sidebar/nav-sidebar.service';
import { FiltersService } from 'app/core/filters/filters.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'app/core/auth/auth.service';
@Injectable({ providedIn: 'root' })
export class NavigationService {

	private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
	private _snackBar = inject(MatSnackBar);

	_defaultNavigation: FuseNavigationItem[] = [
		{
			id: 'home',
			title: 'Inicio',
			type: 'basic',
			icon: 'heroicons_outline:chart-pie',
			link: '/dashboard',
			function: () => {
				this._filtersService.clearFilters();
			}
		},
		{
			id: 'my_business',
			title: 'Mi negocio',
			type: 'collapsable',
			icon: 'heroicons_outline:building-storefront',
			showArrow: true,
			children: [
				{
					id: 'credit',
					title: 'Mi crédito',
					type: 'basic',
					icon: 'heroicons_outline:credit-card',
					link: '/credit',
					function: () => {
						this._filtersService.clearFilters();
					}
				},
				{
					id: 'sales',
					title: 'Mis pedidos',
					type: 'basic',
					icon: 'heroicons_outline:book-open',
					link: '/sales',
					function: () => {
						this._filtersService.clearFilters();
					}
				},
				{
					id: 'invoices',
					title: 'Mis facturas',
					type: 'basic',
					icon: 'heroicons_outline:currency-dollar',
					link: '/invoices',
					function: () => {
						this._filtersService.clearFilters();
					}
				},
				{
					id: 'profile-data',
					title: 'Mis datos',
					type: 'basic',
					icon: 'heroicons_outline:identification',
					link: '/company-profile'
				},
				{
					id: 'payment-information',
					title: 'Información para pagos',
					type: 'basic',
					icon: 'heroicons_outline:banknotes',
					link: '/payment-information',
					function: () => {
						this._filtersService.clearFilters();
					}
				},
			],
		},
		{
			id: 'products',
			title: 'Productos',
			type: 'basic',
			icon: 'heroicons_outline:shopping-bag',
			showArrow: true,
			function: () => {
				this._navSidebarService.open('categories');
			}
		},
		{
			id: 'branchs',
			title: 'Marcas',
			type: 'basic',
			icon: 'heroicons_outline:tag',
			showArrow: true,
			function: () => {
				this._navSidebarService.open('brands');
			}
		},
		{
            id: 'general_information',
            title: 'Información general',
            type: 'collapsable',
            icon: 'heroicons_outline:bars-3-bottom-left',
			showArrow: true,
            children: [
                {
                    id: 'branch',
                    title: 'Sucursales',
                    type: 'basic',
					icon: 'heroicons_outline:map-pin',
                    link: '/branches',
					function: () => {
						this._filtersService.clearFilters();
					}
                },
                {
                    id: 'faqs',
					title: 'Preguntas frecuentes',
					type: 'basic',
					icon: 'heroicons_outline:information-circle',
					link: '/faqs',
					function: () => {
						this._filtersService.clearFilters();
					}
                }
            ],
        },
		{
			id: 'requests',
			title: 'Soporte',
			type: 'basic',
			icon: 'heroicons_outline:question-mark-circle',
			link: '/requests',
			function:() => {
				this._filtersService.clearFilters();
			}
		},
		{
			id: 'profile',
			title: 'Perfil',
			type: 'basic',
			icon: 'heroicons_outline:user',
			link: '/profile',
			function: () => {
				if (this._router.url.startsWith('/profile')) {
					this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
						this._router.navigate(['/profile'], {
						});
					});
				} else {
					this._router.navigate(['/profile'], {});
				}

			}
		},
		{
			id: 'sing-out',
			title: 'Cerrar sesión',
			type: 'basic',
			icon: 'heroicons_outline:arrow-right-on-rectangle',
			function: () => {
				this.redirectLogIn('Ha concluido su sesión.')
			}
		}
	];

	constructor(
		private _productService: ProductService,
		private _router: Router,
		private _navSidebarService: NavSidebarService,
		private _filtersService: FiltersService,
		private _authService: AuthService,
		) {
		// this.loadDynamicNavigation();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Accessors
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Getter for navigation
	 */
	get navigation$(): Observable<Navigation> {
		return this._navigation.asObservable();
	}

	// Cierre de sesion
	redirectLogIn(message: any){
		this._authService.signOut().subscribe({
			next: (res) => {
				this._router.navigate(['sign-in']);
				this.openSnackBar(message, true);
			},
			error: (error) => {
				console.error('Error en la petición:', error);
				//Redirigue automaticamente al inicio de sesion
				this._router.navigate(['sign-in']);
				this.openSnackBar(message, true);
			}
		});
	}
	//Mensaje
	openSnackBar(message: string, isSuccess: boolean): void {
		this._snackBar.open(message, '', {
		  horizontalPosition: 'right',
		  verticalPosition: 'top',
		  duration: 4000,
		  panelClass: [isSuccess ? 'success-snackbar' : 'error-snackbar', 'center-text-snackbar'],
		});
	  }

	/**
	 * Get all navigation data
	 */
	get(): Observable<Navigation> {
		let navigation = {
			default: this._defaultNavigation
		};
		this._navigation.next(navigation);
		return of(navigation);
	}
}
